import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT, IEnvironment } from '@trade-platform/ui-utils';

@Injectable()
export class OrderSubmitService {
    private http = inject(HttpClient);
    private environment = inject<IEnvironment>(ENVIRONMENT);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    orderSubmit(orderId: string, note?: string): Observable<null> {
        return this.http.post<null>(`${this.environment.api}orders/${orderId}/submit`, {
            id: orderId,
            ...(note ? { note } : {})
        });
    }
}
